import { useMemo } from 'react';
import dayjs from 'dayjs';

import { DEFAULT_DATE_FORMAT } from '@/common/constants';
import { OrganizationStatus } from '@/modules/employee/Employee/Employee.types';
import { useGeneralInfoStore } from '@/modules/employee/Employee/PersonalInformation/GeneralInfo/stores';

export const buildFutureEmploymentHint = (activeEmploymentDate: string) =>
  `Dependent cards can be added on or after ${activeEmploymentDate} once the employment status is active.`;

export const useFutureDatedEmployee = () => {
  const { employmentStatuses } = useGeneralInfoStore((state) => state.state);

  const effectiveFutureStatus = useMemo(
    () => employmentStatuses?.find((item) => item.status === OrganizationStatus.future && item.isActive),
    [employmentStatuses]
  );

  const isFutureDatedEmployee = Boolean(effectiveFutureStatus);

  const activeEmploymentDate = useMemo(() => {
    const validFrom = effectiveFutureStatus?.validFrom;
    const parsed = dayjs(validFrom);
    return validFrom && parsed.isValid() ? parsed.format(DEFAULT_DATE_FORMAT) : '';
  }, [effectiveFutureStatus?.validFrom]);

  const futureEmploymentHint = useMemo(
    () => buildFutureEmploymentHint(activeEmploymentDate),
    [activeEmploymentDate]
  );

  return {
    isFutureDatedEmployee,
    activeEmploymentDate,
    futureEmploymentHint,
  };
};
